/* src/components/pages/Comconcil.jsx - Modificado el 24-03-2026 */
/* ----------- consulta Comprobantes de conciliación ----------- */

import React, {
  useState,
  useEffect,
} from 'react';

import {
  TextField,
  Typography,
  Divider,
  MenuItem,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Card,
  CardContent,
  CardHeader,
  Stack,
  CircularProgress
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync } from "../utils/exportUtils";

import {
  RiFileSearchLine,
  RiFilePdf2Fill,
  RiFileList2Fill,
  RiReplyAllFill,
  RiSlackFill,
  RiFolderDownloadLine
} from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import { normalizeRut } from "../utils/rutUtils";
import { formatFecha } from "../utils/dateUtils";
import { formatoCLP } from "../utils/montoclpUtils";


const Comconcil = ({ modo }) => {
  const { user } = useAuth();

  const [ano, setAno] = useState(new Date().getFullYear()); // Inicializa con el año actual
  const [mes, setMes] = useState(0); // inicialmente "Todos"

  const [dataconciliacion, setConciliacion] = useState([]);
  const [datapagosdet, setPagosdet] = useState([]); // Estado para datos de pagosdet
  const [loading, setLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);

  const [selectedPago, setSelectedPago] = useState(null);

  const [generandoPdf, setGenerandoPdf] = useState(false);
  
  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes
  
  /* funcion para mostrar datos de subtabla */
  const handleSelectRow = (idcomp) => {
    fetchPagosdet(idcomp); // Llamar para obtener los detalles
  };
  
  /* Función para cancelar y limpiar los arreglos */
  const handleCancel = () => {
    setConciliacion([]);
    setPagosdet([]);
  };

  /* Cálculo dinámico de los años */
  const currentYear = new Date().getFullYear(); // Año actual
  const years = Array.from({ length: 7 }, (_, index) => currentYear - index);

  /* Manejo del cambio del año */
  const handleAnoChange = (e) => {
    setAno(e.target.value);
  };

  /* Manejo del cambio del mes */
  const handleMesChange = (e) => {
    setMes(e.target.value);
  };

  /* Manejo de la subtabla */
  useEffect(() => {
  }, [datapagosdet]);
  /*
    Esta dependencia garantizará que cada vez que se actualice
    datapagosdet, se ejecute el useEffect
  */

  const exportToPDF = async () => {
    exportPdfAsync({
      endpointBase: "/conciliacion/pdf",
      payload: {
        idcomp: selectedPago.idcomp,
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };


  /* Solicita exportar a pdf */
  // const handleExportPdf = async () => {
  //   if (!selectedPago) return;

  //   try {
  //     setLoadingPdf(true);

  //     // 1️⃣ Encolar job
  //     const { data } = await api.post("/conciliacion/pdf", {
  //       idcomp: selectedPago.idcomp,
  //     });

  //     const jobId = data.jobId;

  //     // 2️⃣ Polling
  //     let attempts = 0;
  //     const maxAttempts = 15;

  //     const interval = setInterval(async () => {
  //       attempts++;

  //       try {
  //         const response = await api.get(
  //           `/conciliacion/pdf/${jobId}`,
  //           { responseType: "blob", validateStatus: () => true }
  //         );

  //         if (response.status === 200) {
  //           const url = window.URL.createObjectURL(response.data);
  //           window.open(url, "_blank");
  //           clearInterval(interval);
  //           setLoadingPdf(false);
  //         }

  //         if (response.status === 202) {
  //           // aún procesando
  //         }

  //         if (response.headers["content-type"] === "application/pdf") {
  //           const url = window.URL.createObjectURL(response.data);
  //           window.open(url, "_blank");

  //           clearInterval(interval);
  //           setLoadingPdf(false);
  //           return;
  //         }

  //       } catch (err) {
  //         clearInterval(interval);
  //         setLoadingPdf(false);
  //       }

  //       if (attempts >= maxAttempts) {
  //         clearInterval(interval);
  //         setLoadingPdf(false);

  //         showFeedback({
  //           message: "Tiempo de espera agotado para generar el PDF",
  //           severity: "warning",
  //         });
  //       }

  //     }, 1500);

  //   } catch (error) {
  //     setLoadingPdf(false);

  //     showFeedback({
  //       message: "Error al generar el PDF",
  //       severity: "error",
  //     });
  //   }
  // };


  /* Función para obtener los datos de la tabla pagosdet para subtabla */
  const fetchPagosdet = async (idcomp) => {
    try {

      const response = await api.post("/conciliacion/getpagoscon", {
        idcomp
      });

      const pagosdet = response.data.rows;

      if (Array.isArray(pagosdet) && pagosdet.length > 0) {
        setPagosdet(pagosdet);
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setPagosdet([]);
        showFeedback({
          message: "Los datos no fueron encontrados.",
          severity: "error",
        });

      } else {
        setPagosdet([]);
        showFeedback({
          message:
            "No fue posible obtener su solicitud, por favor intente más tarde.",
          severity: "error",
        });
      }
    };
  };

  /* Función para obtener los datos de la tabla conciliacion */
  const fetchPagoshead = async () => {

    setLoading(true);

    try {

      const RutCli = normalizeRut(user.usuario);
      const Anoaconsultar = ano;
      const Mesaconsultar = mes;

      const response = await api.post("/conciliacion/getconciliacion", {
        RutCli,
        Anoaconsultar,
        Mesaconsultar
      });

      if (response.status === 200) {
        if (response.data.success && response.data.rows) {
          setConciliacion(response.data.rows);

        } else {
          setConciliacion([]);
          showFeedback({
            message: "No se encontraron registros para los parámetros ingresados.",
            severity: "warning",
          });
        }
      }
  
    } catch (error) {
      showFeedback({
        message:
          "No fue posible obtener su solicitud, por favor intente más tarde.",
        severity: "error",
      });

    } finally {
      setLoading(false);
    }
  };

  /* Mostrar los detalles de la fila seleccionada */
  const handleRowClick = (row) => {
    setRowDetails(row);
    setOpenDialog(true);
  };


  /* Configuración de MUI DataGrid de comprobantes */
  const columns = [
    {
      field: 'detalle',
      headerName: "Det",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => {
            handleSelectRow(params.row.idcomp);
            setSelectedPago(params.row); /* fila seleccionada */
          }}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),
    },
    {
      field: 'id',
      headerName: "Id",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'idcomp',
      headerName: "Comp.Pago",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'fechabco',
      headerName: 'Fecha Pago',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'banco',
      headerName: 'Banco',
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomban',
      headerName: "Nombre",
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'glosa',
      headerName: "Glosa",
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'monto',
      headerName: "Monto Total",
      width: 155,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return formatoCLP(params.value);
      },
    },
  ];

  /* Configuración de MUI DataGrid de detalles */
  const columnsPagosDet = [
    {
      field: "pagada",
      headerName: "Estado",
      width: 130,
      headerAlign: "center",
      align: "center",
      sortable: true,

      renderCell: (params) => {
        const pagada = params.value;

        let variant;
        let label;

        if (pagada === 0) {
          variant = "warning";   // Pendiente
          label = "Pendiente";
        } else if (pagada === 1) {
          variant = "success";   // En nómina (flujo OK)
          label = "En Nómina";
        } else if (pagada === 2) {
          variant = "paid";   // Pagada
          label = "Pagada";
        }

        if (!variant) return null;

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={(theme) => {
                const status = theme.custom.ui.status?.[variant];

                return {
                  backgroundColor: status?.bg,
                  color: status?.text,
                  border: `1px solid ${status?.border}`,

                  padding: "5px 10px",
                  borderRadius: "5px",
                  minWidth: 110,
                  height: 22,

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                };
              }}
            >
              {label}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => {
        const { uuid } = params.row;

        const handleOpenPDF = async () => {
          if (!uuid) return;

          try {
            const response = await api.post('/cesiones/getcesionespdf',
              { uuid },
              { responseType: 'blob' }
            );

            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf',
            });

            const url = window.URL.createObjectURL(pdfBlob);
            window.open(url, '_blank');

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);

          } catch (error) {
            showFeedback({
              message: 'No fue posible obtener el Pdf',
              severity: 'error',
            });
          }
        };

        return (
          <Button
            variant="contained"
            aria-label="Abrir PDF"
            onClick={handleOpenPDF}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              minWidth: 0,
              padding: 0,
              width: 32,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            <RiFilePdf2Fill size={20} />
          </Button>
        );
      },
    },
    {
      field: 'detalle',
      headerName: "Info",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleRowClick(params.row)}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),
    },
    {
      field: 'feccesion',
      headerName: 'Fecha Ces.',
      width: 140,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montoces',
      headerName: "Monto Ces.",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return formatoCLP(params.value);
      },
    },
    {
      field: 'rutcedente',
      headerName: "Cedente",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcedente',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'rutcesionario',
      headerName: "Cesionario",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcesionario',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'tipodte',
      headerName: "Dte",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'folio',
      headerName: "Folio",
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'fecemi',
      headerName: "Fecha Emisión",
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montodte',
      headerName: "Monto",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return formatoCLP(params.value);
      },
    },
    {
      field: 'idban',
      headerName: 'Banco',
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomban',
      headerName: 'Nombre',
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ctacte',
      headerName: 'Ctacte',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        pt: 0,
        overflow: 'visible'
      }}>

      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        {/* Rut */}
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Nombre */}
        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Año */}
        <TextField
          id="ano-input"
          select
          label="Año"
          value={ano}
          onChange={handleAnoChange}
          variant="outlined"
          required
          sx={{ width: 90,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {/* Opción "Todos" */}
          <MenuItem key={0} value={0}>
            Todos
          </MenuItem>

          {/* Genera dinámicamente los años desde el año actual hasta 6 años atrás */}
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>

        {/* Mes */}
        <TextField
          id="mes-input"
          select
          label="Mes"
          value={mes}
          onChange={handleMesChange}
          variant="outlined"
          required
          sx={{ width: 100,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {/* Opción "Todos" con valor 0 */}
          <MenuItem key="todos-mes" value={0}>
            Todos
          </MenuItem>

          {Array.from({ length: 12 }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </TextField>

        {/* Botón Buscar */}
        <Button
          variant="contained"
          startIcon={<RiFileSearchLine size={18} />}
          onClick={fetchPagoshead}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Buscar
        </Button>


        {/* Botón Cancelar */}
        <Tooltip title="Cancelar Todo" placement="top" arrow>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: 130,
              height: 40,
              textTransform: 'none',

              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,

              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },

              '&.Mui-disabled': {
                backgroundColor: (theme) =>
                  theme.custom.ui.disabledBg,
                color: (theme) =>
                  theme.custom.ui.disabledText,
              },
            }}
            startIcon={<RiReplyAllFill size={18} />}
          >
            Cancelar
          </Button>
        </Tooltip>

        {/* Botón Exportar a Pdf */}
        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={!selectedPago}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>

      </Stack>

      {/* Configuración MIU DataGrid cabecera */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', /* ajusta según tu layout */
          minHeight: 0,
        }}
      >
        <DataGrid
          rows={dataconciliacion}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            density: 'compact',
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}

          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      /* scroll horizontal cuando corresponde */
            border: 'none',
            /* accesibilidad - foco */
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {dataconciliacion.length.toLocaleString('es-CL')} registros encontrados
      </Typography>


      {/* Configuración MIU DataGrid cabecera */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', /* ajusta según tu layout */
          minHeight: 0,
        }}
      >
        <DataGrid
          rows={datapagosdet}
          columns={columnsPagosDet}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            density: 'compact',
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}

          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      /* scroll horizontal cuando corresponde */
            border: 'none',
            /* accesibilidad - foco */
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {datapagosdet.length.toLocaleString('es-CL')} registros encontrados
      </Typography>


      {/* Dialogo generando pdf */}
      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>


      {/* Dialog para mostrar los detalles de la fila */}
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        aria-labelledby="cesion-detalle-title"
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 8,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
              border: `1px solid ${theme.custom.ui.borderSubtle}`,
            }),
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          id="cesion-detalle-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <RiSlackFill
              size={22}
              color="inherit"
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: (theme) => theme.custom.ui.brandAccent,
              }}
            >
              Detalles de la Cesión
            </Typography>
          </Stack>

          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cerrar
          </Button>
        </DialogTitle>

        <Divider
          sx={{
            borderColor: (theme) => theme.custom.ui.borderSubtle,
            opacity: 0.9,
          }}
        />

        {/* CONTENIDO */}
        <DialogContent
          sx={{
            maxHeight: '75vh',
            overflowY: 'auto',
            px: 2,
            py: 2,
          }}
        >
          {rowDetails && (
            <Stack spacing={2}>
              {/* Datos del Contribuyente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del la Cesión"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />
                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Id Cesión', rowDetails.id],
                    ['Fecha Cesión', rowDetails.feccesion],
                    ['Rut Deudor', rowDetails.rutdeudor],
                    ['Razón Social', rowDetails.nomdeudor],
                    ['Dirección', rowDetails.domdeudor],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos del Cedente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cedente"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cedente', rowDetails.rutcedente],
                    ['Razón Social', rowDetails.nomcedente],
                    ['Dirección', rowDetails.domcedente],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos del Cesionario */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cesionario"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cesionario', rowDetails.rutcesionario],
                    ['Razón Social', rowDetails.nomcesionario],
                    ['Dirección', rowDetails.domcesionario],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos Nota de Crédito */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Nota Crédito"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Folio Nota Crédito', rowDetails.folionc],
                    ['Fecha Emisión', rowDetails.feceminc],
                    ['Monto', rowDetails.montonc],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos Estado de Pago */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) => theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Estado de Pago"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) => theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    [
                      'Estado',
                      rowDetails.pagada === 0
                        ? 'Pendiente'
                        : rowDetails.pagada === 1
                        ? 'En Nómina'
                        : 'Pagada'
                    ],
                    ['Comp. Pago Nro', rowDetails.idpago],
                    [
                      'Fecha de Pago',
                      rowDetails.fechapago
                        ? new Date(rowDetails.fechapago)
                            .toLocaleDateString('es-CL')
                        : '-'
                    ],
                    ['Cant. Documentos', rowDetails.cantidad],
                    ['Monto Total Comp', rowDetails.monto],
                    ['Conciliado', rowDetails.idpago],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Comconcil;
